import {createContext, h} from 'preact'
import {useEffect, useState} from "preact/hooks";
import App from "../components/app";
import {
    getInitInfo,
    getLocalizationKeys,
    getLocations,
    getPopularStylists,
    getSalons
} from "../data-providers/common-data-provicer";
import {route} from "preact-router";
import {PER_PAGE_OPTION} from "../constants/settings";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {capitalizeFirstLetter, scrollToTop} from "../utils/functions";

export const HomeContext = createContext({open: false, setOpen: null});

const defaultContex = {
    openedPopup: false,
    locations: [],
    availableCountries: [],
    mainCities: [],
    popupName: '',
    service: null,
    country: null,
    city: null,
    area: null,
    searchText: '',
    salons: [],
    page: 1,
    maxPage: 1,
    searchResultsLoaded: false,
    isNigeria: true,
    isGhana: false,
    isKenya: false,
    isSouthAfrica: false,
}

export default () => {

    const [context, setContext] = useState(defaultContex)
    const [popularStylists, setPopularStylists] = useState([])
    const [localization, setLocalization] = useState({})
    const [settings, setSettings] = useState({})

    const {executeRecaptcha} = useGoogleReCaptcha();
    const handleReCaptchaVerify = async () => {
        let env = process.env.PREACT_APP_ENV || 'prod'
        if (window.navigator.userAgent.indexOf('HeadlessChrome') && env === 'stg') {
            return ''
        }
        return  await executeRecaptcha('searchSubmit');
    };


    const setSearch = (search) => {
        if (!search) {
            setContext({...context, searchText: ''});
            return;
        }
        const updatedContext = {
            ...context,
            searchText: search,
            openedPopup: false,
            popupName: '',
            page: 1,
            salons: [],
        }

        handleReCaptchaVerify().then(token => {
            getSalonsList(updatedContext, token)
        })

    }

    const getSalonsList = async (params, token = '', cityId = null) => {
        if (params.page === 1) scrollToTop();
        console.log('getSalonsList method')
        setContext({...params, searchResultsLoaded: false, popupName: '', openedPopup: false})
        route('/stylists')
        const res = await getSalons(params.country?.id, cityId || params.city?.id, params.area?.id, params.service?.categorySlug, params.searchText, params.page, PER_PAGE_OPTION, token);
        console.log('Result from backend', res.data)
        setContext({...params,
            salons: [...new Map(params.salons.concat(res.data).map(item =>
                [item['stylist_id'], item])).values()],
            maxPage: res.max_page || res.meta.last_page,
            searchResultsLoaded: true
        });

    }

    const setCountry = (co) => {
        setContext({
            ...context,
            page: 1,
            salons: [],
            country: co,
            isNigeria: co.name !== 'Ghana' && co.name !== 'Kenya' && co.name !== 'South Africa',
            isGhana: co.name === 'Ghana',
            isKenya: co.name === 'Kenya',
            isSouthAfrica: co.name === 'South Africa',
            popupName: 'cities',
            city: null,
            area: null,
            openedPopup: true,
        })
    }
    const setCity = (c) => {
        const updatedContext = {
            ...context,
            page: 1,
            searchText: '',
            salons: [],
            city: c,
            area: null,
        }
        if (c.areas.length) {
            updatedContext.popupName = 'areas'
            updatedContext.openedPopup = true
            setContext(updatedContext)
        } else {
            updatedContext.popupName = '';
            updatedContext.openedPopup = false;
            setContext(updatedContext)
            handleReCaptchaVerify().then(token => {
                getSalonsList(updatedContext, token)
            })
        }

    }
    const setArea = (a) => {
        const updatedContext = {
            ...context,
            page: 1,
            salons: [],
            popupName: '',
            openedPopup: false,
            area: a
        }
        setContext(updatedContext)
        handleReCaptchaVerify().then(token => {
            getSalonsList(updatedContext, token)
        })
    }

    const setService = (service) => {
        console.log(service)
        const updatedContext = {
            ...context,
            searchText: '',
            page: 1,
            salons: [],
            service
        }

        console.log('Locations', context.locations)
        if (context.locations.length > 1 && !context.country) {
            console.log('Open popup countries')
            updatedContext.popupName = 'countries';
        } else if (context.locations.length === 1 || context.country) {
            console.log('Open popup cities')
            updatedContext.country = context.locations[0];
            updatedContext.popupName = 'cities'

        } else {
            console.log('Open salons list instead of popup')
            updatedContext.popupName = '';
            updatedContext.openedPopup = false
            handleReCaptchaVerify().then(token => {
                getSalonsList(updatedContext, token)
            })
        }
        setContext(updatedContext)
    }

    const findInCapital = (capital) => {
        let  city;
        if (capital === 'Lagos') {
            city = context.mainCities.filter((el) => el.name === 'Lagos')[0]
        } else if (capital === 'Accra'){
            city = context.mainCities.filter((el) => el.name === 'Accra')[0]
        } else if (capital === 'Johannesburg') {
            city = context.mainCities.filter((el) => el.name === 'Johannesburg')[0]
        } else {
            city = context.mainCities.filter((el) => el.name === 'Nairobi')[0]
        }
        const updatedContext = {
            ...context,
            city,
            page: 1,
            salons: [],
            openedPopup: false,
            popupName: '',
            service: null,
            area: null
        }
        handleReCaptchaVerify().then(token => {
            getSalonsList({...updatedContext, country: context.locations.length > 1 ? null : updatedContext.country}, token)
        })

    }

    useEffect(() => {
        let isNigeria = true;
        let isGhana = false;
        let isKenya = false;
        let isSouthAfrica = false;
        let countryName = 'Nigeria'
        getLocations().then((loc) => {
            if (context.country?.name === 'Ghana' || (loc.locations.length === 1 && loc.locations[0].name === 'Ghana')) {
                isNigeria = false
                isGhana = true
                isKenya = false
                isSouthAfrica = false
                countryName = 'Ghana'
            }
            if (context.country?.name === 'Kenya' || (loc.locations.length === 1 && loc.locations[0].name === 'Kenya')) {
                isNigeria = false
                isGhana = false
                isKenya = true
                isSouthAfrica = false
                countryName = 'Kenya'
            }
            if (context.country?.name === 'South Africa' || (loc.locations.length === 1 && loc.locations[0].name === 'South Africa')) {
                isNigeria = false
                isGhana = false
                isKenya = false
                isSouthAfrica = true
                countryName = 'South Africa'
            }
            let updatedContext = {...context, locations: loc.locations, isNigeria, isKenya, isSouthAfrica, isGhana, availableCountries: loc.availableCountries, mainCities: loc.mainCities}
            if (loc.locations.length === 1) {
                updatedContext.country = loc.locations[0]
            }
            setContext(updatedContext)
        }).then(() => {
            getPopularStylists(6, countryName).then((res) => setPopularStylists(res.data))
        });
        
        
    }, []);
    useEffect(() => {
        getLocalizationKeys().then((res) => {
            let keys = {};
            res.map(el => {
                keys[el.key] = el.value || el.default_value
            })
            setLocalization(keys)
        })
        getInitInfo().then((res) => {
           
            setSettings(res)
        })
        
        
    }, []);
    
    useEffect(() => {
        let countryName = 'Nigeria';
        if (context.isGhana) {
            countryName = 'Ghana'
        }
        if (context.isKenya) {
            countryName = 'Kenya'
        }
        if (context.isSouthAfrica) {
            countryName = 'South Africa'
        }
        getPopularStylists(6, countryName).then((res) => setPopularStylists(res.data))
    }, [context.isNigeria, context.isKenya, context.isGhana, context.isSouthAfrica])

    const openPopup = (popupTitle, resetServices = false) => {
        const updatedContext = {
            ...context,
            openedPopup: true,
            popupName: popupTitle
        }
        if (resetServices) {
            updatedContext.service = null;
        }
        setContext(updatedContext)
    }

    const closePopup = () => {
        setContext({
            ...context,
            openedPopup: false,
            popupName: ''
        })
    }

    const increasePage = () => {
        if (context.page >= context.maxPage) {
            return ;
        }
        const updatedContext = {
            ...context,
            page: context.page + 1
        }
        setContext(updatedContext)
        handleReCaptchaVerify().then(token => {
            getSalonsList(updatedContext, token)
        })
    }
    
    const getTranslation = (key, defaultValue = '', firstToUpper = false) => {
        let val = localization[key] || defaultValue
        if (firstToUpper) {
            return capitalizeFirstLetter(val);
        }
        return val
    }

    return (
        <HomeContext.Provider value={{
            getTranslation,
            increasePage,
            setService,
            setCountry,
            setCity,
            setArea,
            openPopup,
            closePopup,
            setSearch,
            findInCapital,
            popularStylists,
            settings,
            ...context,
            setContext
        }}>
            <App />
        </HomeContext.Provider>
    )
}